(function () {
  function initStickyBuyBar() {
    var anchor = document.querySelector('[data-mgx-atc-anchor]');
    var bar = document.querySelector('[data-mgx-buybar]');
    if (!anchor || !bar) return;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('mgx-buybar--show', scrolledPast);
    });
    observer.observe(anchor);
  }

  function initTopperToggle() {
    document.querySelectorAll('[data-mgx-topper]').forEach(function (wrap) {
      var toggle = wrap.querySelector('input[type="checkbox"]');
      var field = wrap.querySelector('.mgx-topper__field');
      var text = wrap.querySelector('input[type="text"]');
      if (!toggle || !field || !text) return;

      toggle.addEventListener('change', function () {
        field.hidden = !toggle.checked;
        text.required = toggle.checked;
        field.classList.remove('err');
        if (toggle.checked) text.focus();
      });

      text.addEventListener('input', function () {
        field.classList.remove('err');
      });
    });
  }

  function initTopperCartIntercept() {
    document.querySelectorAll('[data-mgx-topper]').forEach(function (wrap) {
      var section = wrap.closest('[data-section]');
      var form = section && section.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      form.addEventListener(
        'submit',
        function (evt) {
          var toggle = wrap.querySelector('input[type="checkbox"]');
          if (!toggle || !toggle.checked) return;

          var text = wrap.querySelector('input[type="text"]');
          var field = wrap.querySelector('.mgx-topper__field');
          if (!text.value.trim()) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            field.classList.add('err');
            text.focus();
            return;
          }

          evt.preventDefault();
          evt.stopImmediatePropagation();

          var idInput = form.querySelector('[name="id"]');
          var qtyInput = section.querySelector('[name="quantity"]');
          var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

          var items = [
            { id: parseInt(idInput.value, 10), quantity: quantity },
            {
              id: parseInt(wrap.dataset.variantId, 10),
              quantity: quantity,
              properties: { 'Texte du topper': text.value.trim() },
            },
          ];

          var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          var body = { items: items };
          if (cart && typeof cart.getSectionsToRender === 'function') {
            body.sections = cart.getSectionsToRender().map(function (s) {
              return s.id;
            });
            body.sections_url = window.location.pathname;
          }

          var submitButton = form.querySelector('[type="submit"]');
          if (submitButton) submitButton.setAttribute('aria-disabled', 'true');

          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (response) {
              if (response.status) {
                console.error(response);
                return;
              }
              if (cart) {
                cart.renderContents(response);
              } else if (window.routes && window.routes.cart_url) {
                window.location = window.routes.cart_url;
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mgx-topper', cartData: response });
              }
            })
            .catch(function (e) {
              console.error(e);
            })
            .finally(function () {
              if (submitButton) submitButton.removeAttribute('aria-disabled');
            });
        },
        true
      );
    });
  }

  function initSizer() {
    var sizer = document.querySelector('[data-mgx-sizer]');
    if (!sizer) return;

    var buttons = sizer.querySelectorAll('[data-mgx-size]');
    var taxNote = sizer.querySelector('[data-mgx-tax-note]');
    var cards = document.querySelectorAll('[data-mgx-sizes]');

    cards.forEach(function (card) {
      var priceEl = card.querySelector('.price');
      if (priceEl) card.dataset.mgxOriginalPrice = priceEl.innerHTML;
    });

    function firstNumber(str) {
      var match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    function formatMoney(cents) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
      try {
        return (cents / 100).toLocaleString('fr-CA', { style: 'currency', currency: currency });
      } catch (e) {
        return (cents / 100).toFixed(2) + ' $';
      }
    }

    function applySize(label) {
      var minPortions = firstNumber(label);
      if (taxNote) {
        var threshold = parseInt(taxNote.dataset.threshold, 10) || 6;
        taxNote.textContent = minPortions >= threshold ? taxNote.dataset.over : taxNote.dataset.under;
      }

      cards.forEach(function (card) {
        var sizes;
        try {
          sizes = JSON.parse(card.dataset.mgxSizes);
        } catch (e) {
          return;
        }
        var match = sizes.filter(function (s) {
          return s.label.toLowerCase().indexOf(label.toLowerCase()) !== -1;
        })[0];
        var priceEl = card.querySelector('.price');
        if (!priceEl) return;

        if (match) {
          priceEl.innerHTML = '<span class="price-item price-item--regular">' + formatMoney(match.price) + '</span>';
          var variantInput = card.querySelector('[data-mgx-variant-input]');
          if (variantInput) variantInput.value = match.id;
          card.classList.toggle('mgx-card--unavailable', !match.available);
        } else if (card.dataset.mgxOriginalPrice) {
          priceEl.innerHTML = card.dataset.mgxOriginalPrice;
          card.classList.remove('mgx-card--unavailable');
        }
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        applySize(btn.dataset.mgxSize);
      });
    });
  }

  function initGalleryFilters() {
    var filterGroup = document.querySelector('[data-mgx-gallery-filters]');
    var gallery = document.querySelector('[data-mgx-gallery]');
    if (!filterGroup || !gallery) return;

    var buttons = filterGroup.querySelectorAll('[data-mgx-filter]');
    var items = gallery.querySelectorAll('[data-mgx-category]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        var filter = btn.dataset.mgxFilter;

        items.forEach(function (item) {
          var show = filter === 'tous' || item.dataset.mgxCategory === filter;
          item.hidden = !show;
        });
      });
    });
  }

  function initGalleryInspiration() {
    var gallery = document.querySelector('[data-mgx-gallery]');
    var inspirationField = document.getElementById('MgxInspirationField');
    var summaryInsp = document.getElementById('MgxSummaryInsp');
    var summaryInspImg = document.getElementById('MgxSummaryInspImg');
    var summaryInspRemove = document.getElementById('MgxSummaryInspRemove');
    if (!gallery) return;

    gallery.querySelectorAll('[data-mgx-inspiration-url]').forEach(function (item) {
      item.addEventListener('click', function () {
        var url = item.dataset.mgxInspirationUrl;
        var label = item.dataset.mgxInspirationLabel || 'Photo choisie';
        if (inspirationField) inspirationField.value = label + ' — ' + url;
        if (summaryInsp && summaryInspImg) {
          summaryInspImg.src = url;
          summaryInsp.hidden = false;
        }
        var form = document.getElementById('MgxPersoForm');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (summaryInspRemove) {
      summaryInspRemove.addEventListener('click', function () {
        if (inspirationField) inspirationField.value = '';
        if (summaryInsp) summaryInsp.hidden = true;
      });
    }
  }

  function initCustomOrderForm() {
    var form = document.querySelector('[data-mgx-custom-form]');
    if (!form) return;

    var sizeSelect = form.querySelector('[data-mgx-summary="size"]');
    var flavorSelect = form.querySelector('[data-mgx-summary="flavor"]');
    var dateInput = form.querySelector('[data-mgx-summary="date"]');
    var optionsWrap = form.querySelector('[data-mgx-summary="options"]');
    var requiredFields = form.querySelectorAll('[data-mgx-required]');

    var summarySize = document.getElementById('MgxSummarySize');
    var summaryFlavor = document.getElementById('MgxSummaryFlavor');
    var summaryOptions = document.getElementById('MgxSummaryOptions');
    var summaryDate = document.getElementById('MgxSummaryDate');
    var meter = document.getElementById('MgxMeter');
    var missing = document.getElementById('MgxMissing');

    var fieldLabels = {
      Nom: 'votre nom',
      email: 'un courriel valide',
      Téléphone: 'votre téléphone',
      'Date de ramassage': 'la date de ramassage',
      'Heure de ramassage': "l'heure de ramassage",
      Taille: 'le nombre de personnes',
      Saveur: 'la saveur',
      Couleurs: 'les couleurs',
      Thème: 'le thème',
    };

    function formatDate(value) {
      if (!value) return 'À choisir';
      var parts = value.split('-');
      var months = [
        'janvier',
        'février',
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        'août',
        'septembre',
        'octobre',
        'novembre',
        'décembre',
      ];
      var month = months[parseInt(parts[1], 10) - 1];
      return parseInt(parts[2], 10) + ' ' + month + ' ' + parts[0];
    }

    var subjectField = document.getElementById('MgxPersoSubject');
    var nameInput = form.querySelector('[name="Nom"]');

    function updateSubject() {
      if (!subjectField) return;
      var base = 'Nouvelle demande de gâteau personnalisé';
      var name = nameInput && nameInput.value.trim();
      subjectField.value = name ? base + ' — ' + name : base;
    }

    function update() {
      updateSubject();
      if (summarySize) summarySize.textContent = sizeSelect.value || 'À choisir';
      if (summaryFlavor) summaryFlavor.textContent = flavorSelect.value || 'À choisir';
      if (summaryDate) summaryDate.textContent = formatDate(dateInput.value);

      if (summaryOptions && optionsWrap) {
        var checked = Array.from(optionsWrap.querySelectorAll('input:checked')).map(function (i) {
          return i.name;
        });
        summaryOptions.textContent = checked.length ? checked.join(', ') : 'Aucune';
      }

      var total = requiredFields.length;
      var filled = 0;
      var missingLabels = [];
      requiredFields.forEach(function (field) {
        if (field.value && field.value.trim() !== '') {
          filled++;
        } else {
          missingLabels.push(fieldLabels[field.name] || field.name);
        }
      });

      var percent = total > 0 ? Math.round((filled / total) * 100) : 0;
      if (meter) meter.style.width = percent + '%';
      if (missing) {
        missing.textContent = missingLabels.length ? 'Il manque : ' + missingLabels.join(', ') : 'Tout est prêt !';
      }
    }

    var timeSelect = document.getElementById('MgxPersoTime');
    if (timeSelect && dateInput) {
      var hoursMap = {};
      try {
        hoursMap = JSON.parse(timeSelect.dataset.mgxHours || '{}');
      } catch (e) {
        hoursMap = {};
      }
      var slotMinutes = parseInt(timeSelect.dataset.mgxSlotMinutes, 10) || 30;

      function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      }

      function populateTime() {
        var previousValue = timeSelect.value;
        timeSelect.innerHTML = '';

        if (!dateInput.value) {
          timeSelect.appendChild(new Option("Choisir d'abord une date", '', true, true));
          timeSelect.options[0].disabled = true;
          return;
        }

        var day = new Date(dateInput.value + 'T00:00:00').getDay();
        var range = hoursMap[String(day)];

        if (!range) {
          var closedOption = new Option('Fermé ce jour — choisissez une autre date', '', true, true);
          closedOption.disabled = true;
          timeSelect.appendChild(closedOption);
          return;
        }

        var parts = range.split('-');
        var openParts = (parts[0] || '').trim().split(':');
        var closeParts = (parts[1] || '').trim().split(':');
        var openMinutes = parseInt(openParts[0], 10) * 60 + (parseInt(openParts[1], 10) || 0);
        var closeMinutes = parseInt(closeParts[0], 10) * 60 + (parseInt(closeParts[1], 10) || 0);

        var placeholder = new Option('Choisir une heure', '', true, true);
        placeholder.disabled = true;
        timeSelect.appendChild(placeholder);

        var found = false;
        for (var m = openMinutes; m <= closeMinutes; m += slotMinutes) {
          var label = pad(Math.floor(m / 60)) + ':' + pad(m % 60);
          var opt = new Option(label, label);
          if (label === previousValue) {
            opt.selected = true;
            placeholder.selected = false;
            found = true;
          }
          timeSelect.appendChild(opt);
        }
        if (!found) timeSelect.value = '';
      }

      dateInput.addEventListener('change', function () {
        populateTime();
        update();
      });
      populateTime();
    }

    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', updateSubject);
    update();

    var fileInput = document.getElementById('MgxFileInput');
    var fileName = document.getElementById('MgxFileName');
    if (fileInput && fileName) {
      fileInput.addEventListener('change', function () {
        fileName.textContent = fileInput.files.length ? fileInput.files[0].name : 'Glissez une image ou cliquez pour choisir';
      });
    }
  }

  function initOrderFab() {
    var anchor = document.querySelector('.mgx-order__head');
    var fab = document.querySelector('[data-mgx-order-fab]');
    if (!anchor || !fab) return;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      fab.hidden = !scrolledPast;
    });
    observer.observe(anchor);
  }

  function initPortionsCalculator() {
    var calc = document.querySelector('[data-mgx-portions]');
    if (!calc) return;

    var guestsInput = calc.querySelector('[data-mgx-guests]');
    var guestsOut = calc.querySelector('[data-mgx-guests-out]');
    var momentButtons = calc.querySelectorAll('[data-mgx-multiplier]');
    var portionsOut = calc.querySelector('[data-mgx-portions-out]');
    var note = calc.querySelector('[data-mgx-note]');
    var minPortions = parseInt(calc.dataset.minPortions, 10) || 0;
    var multiplier = momentButtons.length ? parseInt(momentButtons[0].dataset.mgxMultiplier, 10) : 2;

    function compute() {
      var guests = parseInt(guestsInput.value, 10) || 0;
      if (guestsOut) guestsOut.textContent = guests;

      var portions = Math.max(minPortions, Math.ceil((guests * multiplier) / 5) * 5);
      if (portionsOut) portionsOut.textContent = portions;

      if (note) {
        if (portions <= minPortions) {
          note.textContent = 'Portions minimum pour une commande.';
        } else if (portions >= 200) {
          note.textContent = 'Idéal pour un grand groupe.';
        } else {
          note.textContent = 'Parfait pour un plateau généreux.';
        }
      }

      var portionsField = document.getElementById('MgxQuotePortions');
      if (portionsField) portionsField.value = portions;
    }

    if (guestsInput) guestsInput.addEventListener('input', compute);
    momentButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        momentButtons.forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        multiplier = parseInt(btn.dataset.mgxMultiplier, 10);
        compute();
      });
    });

    compute();
  }

  function initQuoteForm() {
    var form = document.querySelector('[data-mgx-quote-form]');
    if (!form) return;

    var subjectField = document.getElementById('MgxQuoteSubject');
    var nameInput = form.querySelector('[name="Nom"]');
    if (!subjectField || !nameInput) return;

    var baseSubject = subjectField.value;

    function updateSubject() {
      var name = nameInput.value.trim();
      subjectField.value = name ? baseSubject + ' — ' + name : baseSubject;
    }

    form.addEventListener('input', updateSubject);
    form.addEventListener('submit', updateSubject);
  }

  function initFlavorPicker() {
    var picker = document.querySelector('[data-mgx-flavor-picker]');
    if (!picker) return;

    var maxChoices = parseInt(picker.dataset.maxChoices, 10) || 4;
    var slots = picker.querySelectorAll('[data-mgx-flavor-slot]');
    var variantTitles = [];
    try {
      variantTitles = JSON.parse(picker.dataset.variantTitles);
    } catch (e) {
      variantTitles = [];
    }

    function firstNumber(str) {
      var match = (str || '').match(/\d+/);
      return match ? parseInt(match[0], 10) : maxChoices;
    }

    function applyCount(count) {
      count = Math.min(Math.max(count, 1), maxChoices);
      slots.forEach(function (slot) {
        var index = parseInt(slot.dataset.slotIndex, 10);
        var visible = index <= count;
        slot.hidden = !visible;
        var select = slot.querySelector('[data-mgx-flavor-select]');
        if (select) select.disabled = !visible;
      });
    }

    function applyForVariantId(variantId) {
      var match = variantTitles.filter(function (v) {
        return String(v.id) === String(variantId);
      })[0];
      var count = match ? firstNumber(match.title) : maxChoices;
      applyCount(count);
    }

    applyForVariantId(picker.dataset.currentVariantId);

    var section = picker.closest('[data-section]');
    var variantInput = section && section.querySelector('.product-variant-id');
    if (variantInput) {
      variantInput.addEventListener('change', function () {
        applyForVariantId(variantInput.value);
      });
    }
  }

  function initCarousels() {
    document.querySelectorAll('[data-mgx-carousel]').forEach(function (root) {
      if (root.dataset.mgxReady) return;
      root.dataset.mgxReady = '1';

      var track = root.querySelector('[data-mgx-carousel-track]');
      var prev = root.querySelector('[data-mgx-carousel-prev]');
      var next = root.querySelector('[data-mgx-carousel-next]');
      var dots = root.querySelectorAll('.mgx-carousel__dot');
      if (!track) return;

      function cards() {
        return track.querySelectorAll('[data-mgx-carousel-card]');
      }

      function step() {
        var list = cards();
        if (list.length > 1) return list[1].offsetLeft - list[0].offsetLeft;
        return track.clientWidth;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var left = track.scrollLeft;
        if (prev) prev.disabled = left <= 1;
        if (next) next.disabled = left >= max - 1;

        if (!dots.length) return;
        var index = left >= max - 1 ? dots.length - 1 : Math.round(left / step());
        index = Math.max(0, Math.min(dots.length - 1, index));
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            update();
          });
        },
        { passive: true }
      );
      window.addEventListener('resize', update);

      // Éditeur de thème : amène la carte sélectionnée dans la vue
      document.addEventListener('shopify:block:select', function (evt) {
        if (!root.contains(evt.target)) return;
        track.scrollTo({ left: evt.target.offsetLeft - cards()[0].offsetLeft, behavior: 'smooth' });
      });

      update();
    });
  }

  // Grille de photos : un clic agrandit la photo (délégué, survit au rechargement de section dans l'éditeur)
  function initLightbox() {
    document.addEventListener('click', function (evt) {
      var dialog = document.querySelector('[data-mgx-lightbox-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var img = dialog.querySelector('[data-mgx-lightbox-img]');

      var trigger = evt.target.closest('[data-mgx-lightbox]');
      if (trigger) {
        img.src = trigger.getAttribute('data-mgx-lightbox');
        img.alt = trigger.getAttribute('data-mgx-lightbox-alt') || '';
        dialog.showModal();
        return;
      }

      // Bouton fermer, ou clic sur le fond sombre
      if (evt.target.closest('[data-mgx-lightbox-close]') || evt.target === dialog) {
        dialog.close();
        img.removeAttribute('src');
      }
    });
  }

  document.addEventListener('shopify:section:load', initCarousels);

  document.addEventListener('DOMContentLoaded', function () {
    initCarousels();
    initLightbox();
    initStickyBuyBar();
    initTopperToggle();
    initTopperCartIntercept();
    initSizer();
    initGalleryFilters();
    initGalleryInspiration();
    initCustomOrderForm();
    initOrderFab();
    initPortionsCalculator();
    initQuoteForm();
    initFlavorPicker();
  });
})();
